<template>
  <div>
    <el-divider content-position="left">{{ $t('basicData.PriceDetails') }}2</el-divider>

    <div class="feet-r mb10">
      <!-- 增加一行 -->
      <el-button
        v-permit:remove="'btn:payable:quoteManagement:addEdit'"
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddARow') }}</el-button>

      <!-- 下载/导入 -->
      <importAndDownloadCmp
        :subregion-list="subregionList"
        :fee-list="feeTypeList"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />
      <!-- 清空报价 -->
      <el-popover placement="bottom-start" trigger="hover">
        <!-- 清空当前分区 -->
        <div class="feet">
          <el-button
            size="small"
            type="primary"
            @click="clearOffers(1)"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!-- 清空所有分区 -->
          <el-button
            class="feet-btn"
            size="small"
            type="primary"
            @click="clearOffers(2)"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <template #reference>
          <el-button
            size="small"
            plain
          >{{ $t('basicData.ClearTheOffer') }}
          </el-button>
        </template>
      </el-popover>
    </div>

    <TableCmp
      ref="tableRef"
      :fee-list="feeTypeList"
      :table-data="currentTableData"
      @change="handleTableChange"
    />

  </div>
</template>

<script>
import { validatePrice, SEPARATOR } from './utils';

// 提交模板
const ROW_TMP = {
  'offerPriceId': undefined, // id 提交的时候需要
  'partitionId': null, // 分区id
  'partitionAffiliateId': null, // 分区关联id
  'feeTypeCode': '',
  'startOfGoodsQuantity': '',
  'endOfGoodsQuantity': '',
  'price': ''
};

export default {
  components: {
    TableCmp: () => import('./TableCmp.vue'),
    importAndDownloadCmp: () => import('./importAddDownloadCmp.vue')
  },

  props: {
    // 报价id
    ids: {
      type: Number,
      default: 0
    },
    // 分区方案id
    partitionId: {
      type: [Number, String],
      default: ''
    },
    // 当前分区id
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },
    // 分区明细
    subregionList: {
      type: Array,
      default: () => []
    },
    // 费用类型
    feeTypeList: {
      type: Array,
      default: () => []
    },
    // table数据
    dataList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // 如果没有选择分区
      defaultPartitionObj: {
        arr: []
      },

      // 如果选择了分区
      partitionObj: {
        // 分区id1: { arr: [] },
        // 分区id2: { arr: [] },
      },

      // 新增：缓存待处理的数据列表
      pendingDataList: []
    };
  },

  computed: {
    // 无分区方案、无分区ID
    hasNoPartition() {
      return !this.partitionId && !this.partitionAffiliateId;
    },
    // 有分区ID
    hasPartitionAffiliate() {
      return Boolean(this.partitionAffiliateId);
    },
    // 当前分区table数据
    getPartitionArr() {
      return this.partitionObj[this.partitionAffiliateId]?.arr || [];
    },
    currentTableData() {
      return this.hasNoPartition
        ? this.defaultPartitionObj.arr
        : this.getPartitionArr;
    },
    // 新增：判断分区数据是否已初始化
    isPartitionDataReady() {
      // 如果partitionAffiliateId存在，则检查subregionList是否有数据
      if (this.hasPartitionAffiliate) {
        // 其他业务类型：检查分区数据
        return this.subregionList && this.subregionList.length > 0;
      }

      // 没有partitionAffiliateId
      return true;
    }
  },

  watch: {
    // 分区明细变化
    subregionList: {
      handler(newVal, oldVal) {
        // 只有当数据实际变化时才执行初始化
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.initializeData();
          console.log('mdd-初始化1', this.partitionObj);
          // 如果有待处理的数据，执行设置数据
          if (this.pendingDataList.length > 0) {
            this.setData(this.pendingDataList);
            this.pendingDataList = []; // 清空缓存
          }
        }
      },
      deep: true
      // immediate: true
    },
    // 表格数据监听
    dataList: {
      handler(val) {
        if (val.length === 0) {
          this.pendingDataList = []; // 清空缓存
          return;
        }

        // 如果分区数据未准备好，缓存数据
        if (!this.isPartitionDataReady) {
          console.log('分区数据未准备好，缓存数据等待初始化', val);
          this.pendingDataList = [...val]; // 缓存数据副本
          return;
        }

        this.initializeData();
        this.setData(val);
      },
      deep: true
      // immediate: true
    }
  },

  methods: {
    // 初始化分区
    initializeData() {
      this.partitionObj = {};

      // 无分区
      if (this.hasNoPartition) {
        this.defaultPartitionObj.arr = [];
        return;
      }
      this.initializeSubregionData();
      console.log('mdd-初始化完成', this.partitionObj);
    },

    /**
     * 初始化分区明细数据
     */
    initializeSubregionData() {
      if (!this.subregionList.length) return;

      this.subregionList.forEach(item => {
        this.$set(this.partitionObj, item.id, { arr: [] });
      });
    },

    /**
     * 增加一行
     */
    handleAdd() {
      const row = { ...ROW_TMP };
      try {
        if (this.hasNoPartition) {
          this.defaultPartitionObj.arr.push(row);
          return;
        }

        // 选择了分区
        this.partitionObj[this.partitionAffiliateId].arr.push(row);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 处理表格数据变化
     */
    handleTableChange(arr) {
      if (!arr?.length) return;

      if (this.hasNoPartition) {
        this.defaultPartitionObj.arr = arr;
      } else {
        this.partitionObj[this.partitionAffiliateId].arr = arr;
      }
    },

    /**
     * 设置数据
     * @param dataArr
     */
    setData(dataArr) {
      console.log('setData-mdd-规则', dataArr);
      if (dataArr.length === 0) return;
      try {
        if (this.hasNoPartition) {
          this.defaultPartitionObj.arr = dataArr.map(item => ({
            ...ROW_TMP,
            ...item
          }));
          return;
        }
        // 选择了分区
        for (const item of dataArr) {
          const { partitionAffiliateId } = item;
          // 排除无效键值
          if (!partitionAffiliateId) continue;
          if (!this.partitionObj[partitionAffiliateId]) {
            // 如果分区不存在，先初始化
            this.partitionObj[partitionAffiliateId] = { arr: [] };
          }
          this.partitionObj[partitionAffiliateId].arr.push(item);
        }
        console.log('mdd-setData-更新完成', this.partitionObj);
      } catch (error) {
        console.log(error);
      }
    },

    // 获取数据
    getData() {
      const arr = [];
      // 未选择分区
      if (this.hasNoPartition) {
        return this.defaultPartitionObj.arr.map(item => {
          return {
            ...ROW_TMP,
            ...item,
            partitionAffiliateId: undefined
          };
        });
      }
      // 选择了分区，将所有数据（二维数组）放入arr（一维数组）中
      Object.entries(this.partitionObj)
        .filter(([_, partition]) => partition.arr.length > 0)
        .forEach(([affiliateId, partition]) => {
          const list = partition.arr.map(item => ({
            ...ROW_TMP,
            ...item,
            offerPriceId: this.ids,
            partitionId: this.partitionId,
            partitionAffiliateId: affiliateId
          }));
          arr.push(...list);
        });

      console.log('mdd-提交数据', arr);
      return arr;
    },

    /**
     * 提交校验
     *    1. 直接校验当前分区
     *    2. 其他分区填写的数据校验
     */
    async submitForm() {
      // 无分区
      if (this.hasNoPartition) {
        // 无数据（非必填）
        if (!this.defaultPartitionObj.arr.length) {
          return true;
        }

        // 存在数据，校验必填项
        const isBool = await this.$refs.tableRef.submitForm();
        if (!isBool) {
          this.$message.warning(this.$t('operatingPlatform.PleaseFillInTheRequiredFields'));
          return false;
        }
        return true;
      }

      // 选择了分区方案
      {
        // 校验当前分区
        const isBool = await this.$refs.tableRef.submitForm();

        if (!isBool) {
          this.$message.warning(this.$t('basicData.CheckFail'));
          return false;
        }
      }
      // 存在其他分区，校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validatePrice(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的分区
        const dataList = this.subregionList;
        if (arr.length > 0) {
          // 获取不通过的分区名称
          const list = dataList.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.partitionIdentifier;
          }).join(',');
          this.$message.error('mdd价格详情2的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }
      return true;
    },

    // 下载报价回调函数
    onDownloadOffer() {
      const list = this.getData();

      const buildMapById = (arr) => {
        const map = new Map();
        arr.forEach(item => {
          if (item && typeof item.id !== 'undefined') {
            map.set(item.id, item);
          }
        });
        return map;
      };

      const subregionListMap = buildMapById(this.subregionList);

      const specialFeeMap = new Map();
      this.feeTypeList.forEach(fee => {
        if (fee && fee.code) {
          specialFeeMap.set(fee.code, fee);
        }
      });

      return list.map(item => {
        const { id, partitionAffiliateId, feeTypeCode, startOfGoodsQuantity, endOfGoodsQuantity, price } = item;

        const obj = {
          id,
          partitionAffiliateId: '', // 分区关联id
          feeTypeCode: '', // 费用类型处理
          startOfGoodsQuantity,
          endOfGoodsQuantity,
          price
        };

        const targetMap = subregionListMap;
        let convertedId = Number(partitionAffiliateId);
        if (isNaN(convertedId)) {
          convertedId = null; // 明确无效数字处理
        }

        // 处理分区/车线名称
        if (convertedId !== null && targetMap.has(convertedId)) {
          const partitionAffiliateObj = targetMap.get(convertedId);
          const { partitionIdentifier, id: pid, name } = partitionAffiliateObj || {};
          obj.partitionAffiliateId = `${partitionIdentifier || name || ''}${SEPARATOR}${pid}`;
        }

        // 费用类型处理
        if (specialFeeMap.has(feeTypeCode)) {
          const feeObj = specialFeeMap.get(feeTypeCode);
          obj.feeTypeCode = `${feeObj.name}${SEPARATOR}${feeTypeCode}`;
        }

        return obj;
      });
    },

    // 导入数据
    onImportList(arr) {
      console.log(arr, 'mdd-导入数据-443');
      // 数据校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validatePrice(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的分区
        const dataList = this.businessType === 5 ? this.stitchingLine : this.subregionList;
        if (arr.length > 0) {
          // 获取不通过的分区名称
          const list = dataList.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.partitionIdentifier;
          }).join(',');

          this.$message.error('mdd价格详情2的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }
      this.setData(arr);
    },

    /**
     * @description 清空报价
     * @param {Number} type 1:清空当前分区 2:清空所有分区
     */
    clearOffers(type) {
      // 无分区
      if (this.hasNoPartition) {
        this.defaultPartitionObj.arr = [];
      } else {
        // 选择分区
        if (type === 1 && Object.keys(this.partitionObj)?.length) {
          this.partitionObj[this.partitionAffiliateId].arr = [];
        } else {
          for (const key in this.partitionObj) {
            this.partitionObj[key].arr = [];
          }
        }
      }
    }
  }
};
</script>

